<template>
  <div id="stripe-session-container" />
</template>

<script>
import { loadConnectAndInitialize } from '@stripe/connect-js'
import { stripeAPIToken } from 'src/config'
import Payment from 'src/models/payment/Payment'

export default {
  name: 'StripeSessionDispute',
  props: {
    type: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: true
    },
    payment: {
      type: Payment,
      default: null
    }
  },
  watch: {
    isActive: {
      handler () {
        if (this.isActive) {
          this.loadConnectContainer()
        }
      },
      immediate: true
    }
  },
  models: {
    stripeDestinationPayment: {
      variables () {
        return {
          paymentId: this.payment.id,
          skip: _.isNil(this.payment?.id)
        }
      },
      immediate: false
    },
    stripeDisputeSession: {
      variables () {
        return {
          paymentId: this.payment.id,
          skip: _.isNil(this.payment?.id)
        }
      },
      immediate: false
    }
  },
  methods: {
    async getStripeAccountSession () {
      await this.$nextTick()
      await this.stripeDisputeSession.fetch(true)
      return this.stripeDisputeSession.value.secret
    },
    async loadConnectContainer () {
      const stripeConnectInstance = loadConnectAndInitialize({
        publishableKey: stripeAPIToken,
        fetchClientSecret: this.getStripeAccountSession
      })

      await this.$nextTick()
      await this.stripeDestinationPayment.fetch(true)
      const component = stripeConnectInstance.create(this.type)
      component.setPayment(this.stripeDestinationPayment.value.stripe_payment_id)

      const container = document.getElementById('stripe-session-container')
      container.appendChild(component)
    }
  }
}
</script>
